module.exports = __webpack_public_path__ + "img/lg_ring_g_o_0_1@3x.11af8fbf.png";